<template>
  <div class="question-meter">
    <h4>{{ question.question_fi }}</h4>
    <div class="wrapper">
      <div v-for="(score, key) in scores" :key="key" class="score-column">
        <label v-if="key == 1" class="score-label">Täysin eri mieltä</label>
        <label v-if="key == 3" class="score-label"></label>
        <label v-if="key == 5" class="score-label">Täysin samaa mieltä</label>
        <div v-for="party in score" class="party-dot" :key="party.pid" :style="{background: party.color}" :title="party.name_sv"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionMeter',
  props: {
    question: Object,
    regering: Array,
  },
  data () {
    return {
    }
  },
  computed: {
    scores() {
      let scores = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
      };
      for (let i = 0; i < this.regering.length; i++) {
        const party = this.regering[i];
        scores[this.question[party.pid]].push(party);
      }
      return scores;
    },
  },
  created() {
  },
  mounted() {
  },
  watch: {
  },
  methods: {
  },
}
</script>

<style lang="scss">
.question-meter {
  text-align: center;
  margin-bottom: 30px;
  padding: 15px;
  background: #fff;

  h4 {
    margin-top: 0;
    line-height: 1.25;
  }

  .party-dot {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin: 1px;
    z-index: 2;
  }

  .wrapper {
    position: relative;
    display: flex;

    .score-column {
      padding-top: 50px;
      width: 20%;
      float: left;
      min-height: 80px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      text-align: center;
      flex-direction: column;

      .score-label {
        position: absolute;
        top: 10%;
        width: 20%;
        font-size: 14px;
        line-height: 1;
      }

      &:before {
        content: " ";
        width: 2px;
        display: block;
        background-color: #e1e1e1;
        position: absolute;
        top: 70%;
        bottom: 0;
        z-index: 0;
      }
      
      &:nth-child(odd):before {
        top: 50%;
      }
    }

    &:before {
      content: " ";
      height: 2px;
      display: block;
      background-color: #e1e1e1;
      position: absolute;
      left: 10%;
      right: 10%;
      bottom: 0;
    }

    &:after {
      content: "";
      clear: both;
      display: table;
    }
  }
}
</style>

